module.exports = __webpack_public_path__ + "files/5e7bfceeb87ab9f0e1cceeea4842779b.png";